module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    staticClass: "addLuckyRunner",
    attrs: {
      "name": "addLuckyRunner",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "80%",
      "maxWidth": "500"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('h3', [_vm._v("Add LuckyLiveRunner")]), _vm._v(" "), (_vm.invalidError) ? _c('div', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.invalidMsg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-data-outer"
  }, [_c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Race Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.raceId),
      expression: "luckyRunnerData.raceId"
    }],
    domProps: {
      "value": (_vm.luckyRunnerData.raceId)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "raceId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Runner Id ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.runnerId),
      expression: "luckyRunnerData.runnerId"
    }],
    domProps: {
      "value": (_vm.luckyRunnerData.runnerId)
    },
    on: {
      "change": _vm.changeHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "runnerId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Sent")]), _vm._v(" "), _c('date-field', {
    attrs: {
      "name": "presentSentDate"
    },
    model: {
      value: (_vm.luckyRunnerData.presentSentDate),
      callback: function($$v) {
        _vm.$set(_vm.luckyRunnerData, "presentSentDate", $$v)
      },
      expression: "luckyRunnerData.presentSentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("What")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.presentContent),
      expression: "luckyRunnerData.presentContent"
    }],
    domProps: {
      "value": (_vm.luckyRunnerData.presentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "presentContent", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-data"
  }, [_c('label', [_vm._v("Note")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.luckyRunnerData.note),
      expression: "luckyRunnerData.note"
    }],
    domProps: {
      "value": (_vm.luckyRunnerData.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.luckyRunnerData, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    on: {
      "click": function($event) {
        _vm.Save()
      }
    }
  }, [_vm._v("Save")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aba95a12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AddLuckyLiveRunner.vue
// module id = 1711
// module chunks = 1